// Module
var code = "<!-- Border layout -->\n<cjs-border-layout class=\"border-layout-100vh\" ref=\"appLayout\">\n\n    <!-- Pages -->\n    <div slot=\"center\" ref=\"pagesContainer\" class=\"w-100 h-100 p-2 login-app\"></div>\n\n</cjs-border-layout>";
// Exports
module.exports = code;